import { render, staticRenderFns } from "./PatrolDetails.vue?vue&type=template&id=78d1fcb9&scoped=true"
import script from "./PatrolDetails.vue?vue&type=script&lang=js"
export * from "./PatrolDetails.vue?vue&type=script&lang=js"
import style0 from "./PatrolDetails.vue?vue&type=style&index=0&id=78d1fcb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d1fcb9",
  null
  
)

export default component.exports